<template>
  <div class="account">
    <Loading v-if="loading" />
    <div v-if="!loading" class="edit-form py-3">
      <v-layout column align-center>
        <order-card :order="order"> </order-card>
      </v-layout>
    </div>
  </div>
</template>

<script>
import orderApi from "@/api/order";
import store from "@/store/index";
import OrderCard from "@/components/order/OrderCard.vue";
import Loading from "@/components/shared/Loading.vue";

export default {
  components: {
    OrderCard,
    Loading,
  },
  mounted() {
    this.loading = true;
    return orderApi
      .get_order_status(this.$route.params.order_id)
      .then((response) => {
        this.loading = false;
        this.order = response.data;
      })
      .catch(() => {
        this.loading = false;
      });
  },
  data() {
    return {
      user_info: store.state.user,
      loading: false,
      order: null,
      read_only: true,
    };
  },
};
</script>
